import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as o, normalizeClass as s, createElementVNode as d } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const n = {
  name: "DtIconBreakoutRooms",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, l = ["aria-label", "data-qa", "aria-hidden"], m = /* @__PURE__ */ d("path", {
  d: "M7 10h2V8H7v2Zm-5 0h2V8H2v2Zm5-5h3V2H7v3ZM2 5h2V3H2v2Zm3 5.089a.911.911 0 0 1-.911.911H1.91a.911.911 0 0 1-.91-.911V7.91c0-.503.408-.91.911-.911H4.09c.503 0 .91.408.911.911v2.178Zm5 0a.911.911 0 0 1-.911.911H6.91a.911.911 0 0 1-.91-.911V7.91c0-.503.408-.91.911-.911H9.09c.503 0 .91.408.911.911v2.178Zm-5-5A.911.911 0 0 1 4.089 6H1.91A.911.911 0 0 1 1 5.089V2.91c0-.503.408-.91.911-.911H4.09c.503 0 .91.408.911.911v2.18Zm6 0a.911.911 0 0 1-.911.911H6.91A.911.911 0 0 1 6 5.089V1.91c0-.503.408-.91.911-.911h3.178c.503 0 .91.408.911.911v3.18Z",
  fill: "currentColor"
}, null, -1), _ = [
  m
];
function u(e, h, r, f, v, a) {
  return o(), i("svg", {
    "aria-label": r.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--breakout-rooms"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Breakout Rooms",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, _, 10, l);
}
const Z = /* @__PURE__ */ c(n, [["render", u]]);
export {
  Z as default
};
//# sourceMappingURL=breakout-rooms.js.map
